import * as React from "react";
import MuiInputLabel, {
    InputLabelProps as MuiInputLabelProps,
    InputLabelClassKey as MuiInputLabelClassKey
} from "@material-ui/core/InputLabel";

export type InputLabelClassKey = MuiInputLabelClassKey;

export interface InputLabelProps extends MuiInputLabelProps { }

class InputLabel extends React.PureComponent<InputLabelProps> {
    render() {
        const { ...props } = this.props;
        return <MuiInputLabel {...props}>
            {this.props.children}
        </MuiInputLabel>;
    }
}

export default InputLabel; 